import { MixedFont } from "../../PresentationalComponents/MixedFont";
import styles from "./Hero.module.css";

export function Hero({ t }) {
  return (
    <section className={styles.sectionContainer}>
      <div className={styles.heroContainer}>
        <img src="imgs/UI/HeroToLeft.webp" />
        <div className={styles.heroOverlayTxtContainer}>
          <div className={styles.verticalLine}>
            <div></div>
            <label>{t("name")}</label>
          </div>
          <div className={styles.titleDescContainer}>
            <h1>{t("hero.title")}</h1>
            <p>
              <MixedFont inputText={t("hero.description")} />
            </p>
          </div>
          <div className={styles.locationTxt}>
            <h5>{t("hero.location")}</h5>
          </div>
        </div>
      </div>
    </section>
  );
}
